import { render, staticRenderFns } from "./ZyroCssShorthandControl.vue?vue&type=template&id=1dcb9f28&scoped=true&"
import script from "./ZyroCssShorthandControl.vue?vue&type=script&lang=js&"
export * from "./ZyroCssShorthandControl.vue?vue&type=script&lang=js&"
import style0 from "./ZyroCssShorthandControl.vue?vue&type=style&index=0&id=1dcb9f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb9f28",
  null
  
)

export default component.exports